export default __webpack_public_path__ + "static/media/2327.7f32cdcc.png";